import requestApi from "@/utils/requestApi";

import contractPreview from "@/components/contractPreview/contractPreview.vue";
import AddCarDialog from "@/components/AddCarDialog/AddCarDialog.vue";

export default {
  name: "seller_dialog",
  props: {
    order: {
      type: Object,
    },
    orderGoodsList: {
      type: Array,
    },
  },
  watch: {
    orderGoodsList: {
      handler(val) {
        this.goodsListCopy = JSON.parse(JSON.stringify(val || [])).map((item) => ({
          ...item,
          deliveryGoodsQuantity: item.goodsQuantity,
        }));
      },
      immediate: true,
    },
    order: {
      handler(val) {
        console.log("order=========", val);
      },
      immediate: true,
    },
  },
  components: {
    AddCarDialog,
    contractPreview,
  },
  data() {
    return {
      env: process.env,
      orderId: "",
      //改价
      editChangePriceDialogVisible: false,
      changePriceButton: {},
      isSubtractMoney: 0,
      subtractMoney: 0,
      pmoney: 0,
      isSignMaterialStatement: 0,
      changeGoodsList: [],
      finalChangeMoney: 0,
      zkRecord: [],

      /*确认自提*/
      editConfirmSelfPickupDialogVisible: false,
      thisInputPickupCode: "",
      takeGoodsNum: "",
      photoList: [],
      confirmSelfPickupButton: {},
      orderSellerCredential: {},
      sellerVoucherImgUrl: [],

      /*大宗原料确认书*/
      editBalanceConfirmationDialogVisible: false,
      modifyPriceType: [
        {
          value: "1001",
          text: "提前",
        },
        {
          value: "1002",
          text: "延迟",
        },
        {
          value: "1003",
          text: "其他原因",
        },
      ],
      thisModifyPriceType: "",
      modifyPriceValue: "",
      finalSettlementMoney: 0,

      /*收货确认*/
      editReceiptConfirmationDialogVisible: false,
      refundGoodsList: [],
      goodsMoneyAll: 0,
      refundingMoney: 0,
      isNotSave: false,
      // 修改收货信息
      editDeliveryInfo: false,
      orderDeliveryList: [],
      // 联系电话类型
      telTypeList: [
        {
          id: "1",
          name: "手机",
        },
        {
          id: "0",
          name: "电话",
        },
      ],
      // 快递公司
      logisticsCompanyList: [
        {
          code: "yuantong",
          description: "圆通速递",
        },
      ],
      // 订单涉及商品调整
      goodsListCopy: [],
      balanceRefundTotal: 0,

      contractPreviewUrl: "",
      contractPreviewSign: false,
      contractPreviewVisible: false,

      // 导入车辆
      importCarVisible: false,

      // 新增车辆
      addCarVisible: false,
    };
  },
  methods: {
    formatNum6(nums, decimal) {
      let value = `${nums}`;
      value = value.replace(/[^\d.]/g, "");
      value = value.replace(/\.{2,}/g, ".");
      value = value.replace(".", "$#$");
      value = value.replace(/\./g, "");
      value = value.replace("$#$", ".");
      const reg = new RegExp("^(-)?(\\d{1,8})\\.(\\d{0,6}).*$");
      value = value.replace(reg, "$1$2.$3");
      if (value.indexOf(".") < 0 && value !== "" && value !== "-") {
        // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        value = parseFloat(value);
      }
      if (value && !decimal) {
        value = parseInt(value, 10);
      }
      return value;
    },
    formatNums(nums, decimal) {
      let value = `${nums}`;
      value = value.replace(/[^\d.]/g, "");
      value = value.replace(/\.{2,}/g, ".");
      value = value.replace(".", "$#$");
      value = value.replace(/\./g, "");
      value = value.replace("$#$", ".");
      const reg = new RegExp("^(-)?(\\d{1,8})\\.(\\d{0,4}).*$");
      value = value.replace(reg, "$1$2.$3");
      if (value.indexOf(".") < 0 && value !== "" && value !== "-") {
        // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        value = parseFloat(value);
      }
      if (value && !decimal) {
        value = parseInt(value, 10);
      }
      return value;
    },
    //改价
    editPriceOpen(item) {
      this.changePriceButton = item;
      if (item.isSignMaterialStatement == 1) {
        if (item.materialContractFirst != 1) {
          this.$message({
            message: "本订单需要双方签署结算确认书之后才能改价，请前往订单签署确认书",
            type: "warning",
          });
          return;
        }
        if (item.materialContractSecond != 1) {
          this.$message({
            message: "本订单需要双方签署结算确认书之后才能改价，乙方还未签署结算确认书",
            type: "warning",
          });
          return;
        }
      }
      this.isSignMaterialStatement = item.isSignMaterialStatement;
      this.$store.dispatch("orderTo/index/selOrderDetailExtendById", { orderId: item.orderId }).then((data) => {
        this.isSubtractMoney = data.isSubtractMoney || 0;
        this.subtractMoney = data.subtractMoney || 0;
        this.pmoney = data.pmoney || 0;
        this.changeGoodsList = data.orderGoodsBoList || [];
        this.zkRecord = data.zkRecord || [];
        this.editChangePrice();
      });
      this.editChangePriceDialogVisible = true;
    },
    editChangePrice() {
      let finalChangeMoney = 0;
      let freightMoney = 0;
      this.changeGoodsList.forEach((item) => {
        freightMoney = Number(freightMoney) + Number(item.freightMoneyTotal);
        finalChangeMoney = Number(finalChangeMoney) + Number((item.sellFactPrice * item.goodsQuantity).toFixed(2)) + Number(item.freightMoneyTotal);
      });
      this.finalChangeMoney = Number((finalChangeMoney - this.subtractMoney).toFixed(2));
    },
    toChangePriceSubmit() {
      console.log("this.changeGoodsList", this.changeGoodsList);
      let submitForm = {};
      let goodsList = [];
      let freightMoney = 0;
      let goodsMoney_zong = 0;
      if (this.order.isAllowMultiplePayment == 1 && this.order.isOa == 0) {
        this.changeGoodsList.forEach((item, index, list) => {
          freightMoney = Number(freightMoney) + Number(item.freightMoneyTotal);
          let isBalancePriceCheck = item.balancePrice && item.balancePrice > 0 ? true : false;
          if (isBalancePriceCheck && Number(item.balancePrice) >= Number(item.sellFactPrice)) {
            this.$message({
              message: "商品单价不能小于设置的结算价/返点金额，结算价/返点金额为：" + item.balancePrice,
              type: "warning",
            });
            list.length = index + 1;
          }
          goodsMoney_zong += Number(item.sellFactPrice * item.goodsQuantity + Number(item.freightMoneyTotal) - Number(item.splitRebateMoney).toFixed(2));
          let goods = {
            ogId: item.ogId,
            sellFactPrice: item.sellFactPrice,
            goodsQuantity: item.goodsQuantity,
          };
          goodsList.push(goods);
        });
        submitForm.fMoney = fMoney;
        submitForm.subtractMoney = this.subtractMoney;
      } else {
        this.changeGoodsList.forEach((item, index, list) => {
          freightMoney = Number(freightMoney) + Number(item.freightMoneyTotal);
          let isBalancePriceCheck = item.balancePrice && item.balancePrice > 0 ? true : false;
          if (isBalancePriceCheck && Number(item.balancePrice) >= Number(item.sellFactPrice)) {
            this.$message({
              message: "商品单价不能小于设置的结算价/返点金额，结算价/返点金额为：" + item.balancePrice,
              type: "warning",
            });
            list.length = index + 1;
          }
          goodsMoney_zong += Number((item.sellFactPrice * item.goodsQuantity + Number(item.freightMoneyTotal) - Number(item.splitRebateMoney)).toFixed(2));
          let goods = {
            ogId: item.ogId,
            sellFactPrice: item.sellFactPrice,
            goodsQuantity: item.goodsQuantity,
          };
          goodsList.push(goods);
        });
      }
      let fMoney = Number(goodsMoney_zong) - Number(this.subtractMoney);
      if (this.changePriceButton.isSignMaterialStatement != 1 && Number(fMoney) < Number(this.pmoney)) {
        this.$message({
          message: "买家已支付了" + this.order.pmoney + "元的货款，改价后的买家实付金额必须大于买家已支付金额",
          type: "warning",
        });
        return;
      }
      const record = this.zkRecord.filter((record) => record.payTool == "SC_POINTS");
      if (record.length) {
        let amount = record[0].amount != "" && Number(record[0].amount) > 0 ? Number(record[0].amount) : 0;
        if (Number(fMoney) < Number(amount)) {
          this.$message({
            message: "买家已使用积分抵扣" + amount + "元的货款，买家实付金额必须大于买家已使用积分抵扣金额",
            type: "warning",
          });
          return;
        }
      }
      submitForm.orderGoodsJson = JSON.stringify(goodsList);
      submitForm.orderId = this.order.orderId;
      submitForm.freight = freightMoney;
      this.$store.dispatch("orderTo/index/checkOrderMoney", { orderGoodsJson: submitForm.orderGoodsJson }).then((res) => {
        if (res.code == 1) {
          this.$store.dispatch("orderTo/index/saveOrderMoney", submitForm).then((resp) => {
            if (resp.code == "0") {
              this.$message("更新订单成功");
              this.editChangePriceDialogVisible = false;
              this.$emit("loadOrder");
            } else {
              this.$message({
                message: resp.msg || "更新订单失败",
                type: "warning",
              });
            }
          });
        } else {
          this.$message({
            message: res.msg,
            type: "warning",
          });
        }
      });
    },

    changeTelSelect(value) {
      console.log("select: ", value);
      this.$forceUpdate();
    },

    // 修改发货信息 窗口
    editDeliveryInfoOpen(orderId) {
      console.log("orderId: ", orderId);
      this.$store.dispatch("orderTo/index/selDeliveryDetailByOrderId", { orderId: orderId }).then((res) => {
        this.orderDeliveryList = res || [];
        this.orderDeliveryList.forEach((item) => {
          item.telType = "0";
          if (item.logisticInfo && item.logisticInfo.length === 11) {
            item.telType = "1";
          }
        });
        console.log("orderDeliveryList: ", this.orderDeliveryList);
      });
      this.editDeliveryInfo = true;

      // 获取快递公司列表
      requestApi
        .post("scbasic/dataDictionary/selDataDictionaryItemList", {
          dictId: "LOGISTICS_COMPANY",
        })
        .then((res) => {
          if (res.code == "0" && res.data) {
            this.logisticsCompanyList = res.data;
          }
        });
    },
    // 修改发货信息执行
    exEditDeliveryInfo() {
      let modifyList = [];
      let canSave = true;
      let isPhone = true;
      this.orderDeliveryList.forEach((item) => {
        // 快递发货
        if (item.deliveryType === "EXPRESS") {
          if (!item.logisticsCompanyCode || !item.logisticsNum) {
            console.log("快递发货: 数据不完整");
            canSave = false;
          }
        }
        // 送货上门
        if (item.deliveryType === "SHSM") {
          if (!item.logisticsCompanyName || !item.licensePlate || !item.logisticInfo) {
            console.log("送货上门: 数据不完整");
            canSave = false;
          }
        }
        // 物流发货
        if (item.deliveryType === "LOGISTICS") {
          if (!item.logisticsCompanyName || !item.logisticsNum || !item.logisticInfo) {
            console.log("物流发货: 数据不完整");
            canSave = false;
          }
          // 手机号验证
          if (canSave && item.telType === "1") {
            let logisticInfo = item.logisticInfo;
            if (!/^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/.test(logisticInfo)) {
              console.log("物流发货: 手机号格式有误");
              isPhone = false;
            }
          }
        }
        let modifyObj = {};
        modifyObj.logisticsId = item.logisticsId;
        modifyObj.licensePlate = item.licensePlate;
        modifyObj.logisticsCompanyName = item.logisticsCompanyName;
        modifyObj.logisticsCompanyCode = item.logisticsCompanyCode;
        modifyObj.deliveryType = item.deliveryType;
        modifyObj.logisticsInfo = item.logisticInfo;
        modifyObj.goodsQuantity = item.goodsQuantity;
        modifyObj.logisticsNum = item.logisticsNum;
        modifyList.push(modifyObj);
      });
      if (!canSave) {
        this.$message({
          message: "发货信息不完整",
          type: "warning",
        });
        return;
      }
      if (!isPhone) {
        this.$message({
          message: "手机号格式不正确",
          type: "warning",
        });
        return;
      }
      console.log("orderId: ", this.order.orderId);
      console.log("orderDeliveryList: ", this.orderDeliveryList);
      this.$store
        .dispatch("orderTo/index/modifyDeliveryDetail", {
          orderId: this.order.orderId,
          orderDeliveryList: modifyList,
        })
        .then((res) => {
          if (res.code == "0") {
            this.$message.success("保存成功，发货信息已更新");
            window.location.reload();
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    // 上传图片之前
    uploadBefore(file) {
      const { size, type } = file;
      const isVerify = /(jpg|bmp|jpeg|png)$/.test(type);
      const isVerify2 = /(zip)/.test(type);
      let isLt3M = size / 1024 / 1024 < 50;
      let sizeErr = "上传大小不能超过 50MB";
      if (isVerify2) {
        sizeErr = "上传大小不能超过 50MB";
        isLt3M = size / 1024 / 1024 < 50;
      }
      if (!isVerify && !isVerify2) {
        this.$message.error("上传必须是JPG/BMP/JPEG/PNG/ZIP/格式");
      } else if (!isLt3M) {
        this.$message.error(sizeErr);
      }
      return (isVerify || isVerify2) && isLt3M;
    },
    // 上传图片成功之后
    uploadSuccess(res) {
      console.log("上传图片成功之后", res);
      let {
        data: { name, url },
      } = res;
      const isZip = /(zip)$/.test(name);
      let acUrl = url;
      let logoUrl = "";
      if (isZip) {
        logoUrl = "https://files.nxin.com/mobile/public/zip.png";
        url = logoUrl;
      }
      const item = {
        name: name || "",
        url: url || "",
        acUrl: acUrl || "",
      };
      this.photoList.push(item);
    },
    // 删除图片
    uploadRemove(file, fileList) {
      this.photoList = fileList;
    },
    // 上传图片限制
    uploadExceed() {
      this.$message.warning("最多上传五张图片");
    },
    // 确认自提
    confirmSelfDelivery(item) {
      if (this.order.orderDtlBo && this.order.orderDtlBo.pickupCode && this.order.orderDtlBo.pickupCode != "") {
        this.photoList = [];
        this.takeGoodsNum = "";
        this.selSellerCredential();
      }
      this.confirmSelfPickupButton = item;
      this.editConfirmSelfPickupDialogVisible = true;

      this.thisInputPickupCode = "";
      this.balanceRefundTotal = 0;
    },
    selSellerCredential() {
      this.$store.dispatch("orderTo/index/selSellerCredential", { orderId: this.order.orderId }).then((res) => {
        this.orderSellerCredential = res.data || {};
        if (this.orderSellerCredential && this.orderSellerCredential.sellerVoucherImgUrl) {
          this.photoList = [];
          this.orderSellerCredential.sellerVoucherImgUrl.forEach(function (item) {
            const photo = {
              name: name || "",
              url: item || "",
            };
            this.photoList.push(photo);
          });
        }
        this.takeGoodsNum = this.orderSellerCredential ? this.orderSellerCredential.takeGoodsNum : "";
      });
    },
    async submitVoucher(imgList) {
      if (imgList.length == 0) {
        this.$message.warning("请上传文件");
        return;
      }
      let orderVoucher = [];
      let orderVoucherNot = [];
      let promiseList = [];
      let promiseArgList = [];
      imgList.forEach((item) => {
        let voucher = {
          fileType: "ORDER_VOUCHER_PICTURE",
          busType: "SELLER",
          refId: this.order.orderId,
          url: item,
        };
        promiseList.push(this.$store.dispatch("orderTo/index/checkUploadOrderVoucher", { orderId: this.order.orderId, voucherImgUrl: item }));
        promiseArgList.push(voucher);
      });

      const resArr = await Promise.all(promiseList);
      resArr.forEach((res, index) => {
        if (res.code == "0") {
          orderVoucher.push(promiseArgList[index]);
        } else {
          orderVoucherNot.push(promiseArgList[index]);
        }
      });

      if (orderVoucher.length == 0 && orderVoucherNot.length > 0) {
        this.$message.warning("存在不符合要求的图片，请上传提货单或司机相关图片");
        return;
      }
      if (orderVoucherNot.length > 0) {
        this.$confirm("存在不符合要求的凭证，如继续确认自提将自动删除不符合要求的凭证，是否确认自提？", "提示", {
          confirmButtonText: "确认自提",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$store.dispatch("orderTo/index/addOrderVoucherList", { fileList: orderVoucher }).then((res) => {
              this.submitSellerVoucherLoading = false;
              if (res.code == "0") {
                this.toOrderVehicleStatus();
              } else {
                this.$message.warning("上传失败");
              }
            });
          })
          .catch(() => {
            return;
          });
        return;
      }
      this.$store.dispatch("orderTo/index/addOrderVoucherList", { fileList: orderVoucher }).then((res) => {
        this.submitSellerVoucherLoading = false;
        if (res.code == "0") {
          this.toOrderVehicleStatus();
        } else {
          this.$message.warning("上传失败");
        }
      });
    },
    toOrderVehicleStatus() {
      this.$store.dispatch("orderTo/index/updateOrderVehicleStatus", { orderId: this.order.orderId }).then((res) => {
        if (res.code == "0") {
          this.$message("确认自提成功");
          this.editConfirmSelfPickupDialogVisible = false;
          this.$emit("loadOrder");
        } else {
          this.$message({
            type: "info",
            message: res.msg,
          });
        }
      });
    },
    toConfirmSelfPickupSubmit() {
      // 不走该旧确认自提逻辑, 统一走else
      if (this.order.orderDtlBo.pickupCode == "" && false) {
        this.$store
          .dispatch("orderTo/index/editOrderBySeller", {
            orderId: this.order.orderId,
            takeGoodsNum: this.takeGoodsNum,
            pickupStatus: 1,
          })
          .then(() => {});
        if (this.photoList.length > 0) {
          const imgList = this.photoList.map((item) => item.url);
          this.submitVoucher(imgList);
        } else {
          this.toOrderVehicleStatus();
        }
      } else {
        if (this.order.orderDtlBo.pickupCode) {
          if (this.thisInputPickupCode === "") {
            this.$message.warning("请输入提货码");
            return;
          }
          if (this.thisInputPickupCode.length !== 4) {
            this.$message.warning("请输入正确的提货码");
            return;
          }
        }
        if(this.order.vehicleList && this.order.vehicleList.length) {
          if (this.order.vehicleList.some((item) => !item.actualSendQuantity)) {
            this.$message.warning("请输入实发数量");
            return;
          }
          const actualSendTotal = Number(this.order.vehicleList.reduce((pre, cur) => pre + Number(cur.actualSendQuantity || 0), 0)
        .toFixed(2))
          if(actualSendTotal > Number(this.goodsListCopy[0].goodsQuantity)) {
            this.$message.warning("实发数量不能大于提货数量");
            return;
          }
        }
        if ((!this.order.vehicleList || !this.order.vehicleList.length) && this.goodsListCopy.some((item) => !item.deliveryGoodsQuantity)) {
          this.$message.warning("请输入提货数量");
          return;
        }
        if (this.photoList.length > 0) {
          const imgList = this.photoList.map((item) => {
            let acUrl = item.acUrl;
            let url = item.url;
            if (acUrl) {
              url = acUrl;
            }
            return url;
          });
          this.sellerVoucherImgUrl = imgList;
        }

        const args = {
          orderId: this.order.orderId,
          pickupCode: this.thisInputPickupCode,
          sellerVoucherImgUrl: this.sellerVoucherImgUrl,
          takeGoodsNum: this.takeGoodsNum,
        };
        const confirmSubmit = async () => {
          const { vehicleList } = this.order;
          if (vehicleList && vehicleList.length) {
            const deliveryGoodsQuantity = Number(vehicleList.reduce((pre, cur) => pre + Number(cur.actualSendQuantity || 0), 0).toFixed(2));
            args.vehicleList = vehicleList.map((vItem) => ({ vehicleId: vItem.vehicleId, pickupQuantity: vItem.pickupQuantity, actualSendQuantity: vItem.actualSendQuantity }));
            args.orderGoodsBoList = this.goodsListCopy.map((item) => ({ goodsId: item.goodsId, deliveryGoodsQuantity }));
          } else {
            args.orderGoodsBoList = this.goodsListCopy.map((item) => ({ goodsId: item.goodsId, deliveryGoodsQuantity: item.deliveryGoodsQuantity }));
          }
          const loading = this.$loading({
            lock: true,
            text: "加载中...",
          });
          const { msg, code, data } = await requestApi.post("sctrading/order/mj/sellerConfirmSelfPickUp", args);
          loading.close();
          this.contractPreviewSign = false;
          if (code === "0") {
            if (data && data.isPass === false) {
              this.$confirm(data.tips || "提示", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              })
                .then(() => {
                  if (data.url) {
                    window.location.href = data.url;
                  }
                })
                .catch(() => {});
              return;
            }
            this.editConfirmSelfPickupDialogVisible = false;
            if (data.credentialAuditStatus === 0) {
              this.$message("凭证需后台审核，审核通过后自提成功");
            } else if (data.credentialAuditStatus === 1) {
              this.$message("确认自提成功");
            }
            this.$emit("loadOrder");
          } else {
            this.$message.error(msg);
          }
        };

        if (this.contractPreviewSign) {
          confirmSubmit();
          return;
        }

        this.$store
          .dispatch("orderTo/index/validSellerConfirmSelfPickUpData", {
            // requestApi
            //   .post("sctrading/order/mj/sellerConfirmSelfPickUp", {
            orderId: this.order.orderId,
            pickupCode: this.thisInputPickupCode,
            sellerVoucherImgUrl: this.sellerVoucherImgUrl,
            takeGoodsNum: this.takeGoodsNum,
            goodsList: this.goodsListCopy.map((item) => ({ goodsId: item.goodsId, deliveryGoodsQuantity: item.deliveryGoodsQuantity })),
          })
          .then(async (res) => {
            const { code, msg, data } = res;
            if (code === "1") {
              this.$message(msg);
            } else if (code === "2") {
              let failedPhotoList = data.map((item) => {
                return {
                  url: item,
                  name: "",
                };
              });
              this.photoList = this.photoList.filter((v) => failedPhotoList.every((val) => v.url !== val.url));
              this.$message(msg);
            } else if (code != "0") {
              this.$message.warning(msg);
            } else {
              if (!this.contractPreviewSign) {
                const { vehicleList } = this.order;
                if (vehicleList && vehicleList.length) {
                  const deliveryGoodsQuantity = Number(vehicleList.reduce((pre, cur) => pre + Number(cur.actualSendQuantity || 0), 0).toFixed(2));
                  args.orderGoodsBoList = this.goodsListCopy.map((item) => ({ goodsId: item.goodsId, deliveryGoodsQuantity }));
                } else {
                  args.orderGoodsBoList = this.goodsListCopy.map((item) => ({ goodsId: item.goodsId, deliveryGoodsQuantity: item.deliveryGoodsQuantity }));
                }
                const loading = this.$loading({
                  lock: true,
                  text: "加载中...",
                });
                const { msg, code, data } = await requestApi.post(`sctrading/order/mj/sellerConfirmSelfPickUp/preview `, args);
                loading.close();
                if (code == "0") {
                  if (!data) {
                    confirmSubmit();
                    return;
                  }
                  this.contractPreviewUrl = data;
                  this.contractPreviewVisible = true;
                } else {
                  this.$message.error(msg);
                }
                return;
              }

              // this.$store
              //   .dispatch("orderTo/index/sellerConfirmSelfPickUp", {
              confirmSubmit();
            }
          });
      }
    },
    //签署大宗原料确认书
    editBalanceConfirmationOpen() {
      this.finalSettlementMoney = 0;
      this.orderGoodsList.forEach((item) => {
        item.finalSettlementPrice =
          Number(item.finalSettlementPrice) != Number(item.sellFactPrice) && Number(item.finalSettlementPrice) > 0
            ? item.finalSettlementPrice
            : item.sellFactPrice;
        item.finalSettlementQuantity =
          Number(item.finalSettlementQuantity) != Number(item.goodsQuantity) && Number(item.finalSettlementQuantity) > 0
            ? item.finalSettlementQuantity
            : item.goodsQuantity;
        this.finalSettlementMoney = Number(this.finalSettlementMoney) + Number((item.finalSettlementQuantity * item.finalSettlementPrice).toFixed(2));
      });
      console.log("this.orderGoodsList", this.orderGoodsList);
      this.$store.dispatch("orderTo/index/selOrderDetailExtendById", { orderId: this.order.orderId }).then((data) => {
        this.thisModifyPriceType = data.modifyPriceType || "";
        this.modifyPriceValue = data.modifyPriceValue || "";
      });
      this.editBalanceConfirmationDialogVisible = true;
    },
    thisModifyPriceChange() {
      this.modifyPriceValue = "";
    },
    editFinalSettlement() {
      this.finalSettlementMoney = 0;
      this.orderGoodsList.forEach((item) => {
        this.finalSettlementMoney = Number(this.finalSettlementMoney) + Number((item.finalSettlementQuantity * item.finalSettlementPrice).toFixed(2));
      });
    },
    toSignMaterialSubmit() {
      if (this.thisModifyPriceType == "") {
        this.$message({
          message: "请选择调价事由，并填写信息！",
          type: "warning",
        });
        return;
      }
      if (this.modifyPriceValue == "") {
        this.$message({
          message: "请填写调价事由详情信息！",
          type: "warning",
        });
        return;
      }
      let goodsList = [];
      let money = 0;
      this.orderGoodsList.forEach((item) => {
        money += Number((item.finalSettlementQuantity * item.finalSettlementPrice).toFixed(2));
        let goods = {
          goodsId: item.goodsId,
          goodsPrice: item.finalSettlementPrice,
          goodsQuantity: item.finalSettlementQuantity,
        };
        goodsList.push(goods);
      });
      if (money <= 0) {
        this.$message({
          message: "最终结算总金额必须大于零！",
          type: "warning",
        });
        return;
      }
      let modifyPriceType = {};
      modifyPriceType[this.thisModifyPriceType] = this.modifyPriceValue;
      this.$store
        .dispatch("orderTo/index/toSignMaterialSubmit", {
          orderId: this.order.orderId,
          orderGoodsJson: JSON.stringify(goodsList),
          modifyPriceType: JSON.stringify(modifyPriceType),
        })
        .then((res) => {
          if (res.code == "1") {
            window.open(
              // eslint-disable-next-line max-len
              `${process.env.VUE_APP_APP}contract/toSignMaterialConfirmation.do?orderId=${this.order.orderId}&returnUrl=${window.location.href}`,
              "_blank"
            );
            this.editBalanceConfirmationDialogVisible = false;
            this.$emit("loadOrder");
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });
    },
    //签署大宗原料确认书
    selRefundOrderGoodsList() {
      // 已存在退差额商品数据
      this.$nextTick(function () {
        this.goodsMoneyAll = 0;
        this.refundingMoney = 0;
        this.isNotSave = false;
        this.$store.dispatch("orderTo/index/selRefundOrderGoodsList", { orderId: this.order.orderId }).then((res) => {
          this.refundGoodsList = res.data || [];
          this.refundGoodsList.forEach((item) => {
            if (item.refundStatus === 3) {
              this.isNotSave = true;
              this.refundingMoney += Number(item.goodsMoney);
            }
            item.confirmReceiptGoodsQuantity = Number((Number(item.goodsQuantityAll) - Number(item.goodsQuantityAccum)).toFixed(2));
            item.confirmReceiptGoodsMoney = Number(
              Number((item.goodsPaidInPrice * Number(item.goodsQuantityAll - item.confirmReceiptGoodsQuantity - item.goodsQuantityAccum)).toFixed(2))
            );
            this.goodsMoneyAll = Number(this.goodsMoneyAll) + Number(item.confirmReceiptGoodsMoney);
          });
        });
        this.editReceiptConfirmationDialogVisible = true;
      });
    },
    updateQuantity(orderGoods) {
      let confirmReceiptGoodsQuantity = orderGoods.confirmReceiptGoodsQuantity === "" ? 0 : orderGoods.confirmReceiptGoodsQuantity;
      this.goodsMoneyAll = 0;
      orderGoods.confirmReceiptGoodsMoney =
        Number(orderGoods.goodsPaidInPrice) *
        (Number(orderGoods.goodsQuantityAll) - Number(confirmReceiptGoodsQuantity) - Number(orderGoods.goodsQuantityAccum));
      this.refundGoodsList.forEach((item) => {
        this.goodsMoneyAll = Number(this.goodsMoneyAll) + Number(item.confirmReceiptGoodsMoney);
      });
    },
    saveOrder() {
      var isSave = true;
      var isSaveMsg = "";
      this.refundGoodsList.forEach((item) => {
        if (item.isReceiptConfirmation === 1) {
          if (item.confirmReceiptGoodsQuantity === "" || Number(item.confirmReceiptGoodsQuantity) <= 0) {
            isSaveMsg = "请选择确认收货数量";
            isSave = false;
          }
          if (Number(item.confirmReceiptGoodsQuantity) + Number(item.goodsQuantityAccum) > Number(item.goodsQuantityAll)) {
            isSaveMsg = "确认收货数量已超出货品购买数量，请重新选择确认收货数量；";
            isSave = false;
          }
        }
      });
      if (!isSave) {
        this.$message({
          message: isSaveMsg,
          type: "warning",
        });
        return;
      }
      this.$confirm("确认收货数量后，将直接退还买家差价，且买家不支持售后，请谨慎确认！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$nextTick(function () {
            this.$store
              .dispatch("orderTo/index/updateRefundOrderGoods", {
                orderId: this.order.orderId,
                goodsList: this.refundGoodsList,
              })
              .then((res) => {
                console.log("updateRefundOrderGoods", res);
                if (res.code == "0") {
                  this.editReceiptConfirmationDialogVisible = false;
                  this.refundGoodsList = [];
                  this.goodsMoneyAll = 0.0;
                  this.refundingMoney = 0.0;
                  this.isNotSave = false;
                  this.$emit("loadOrder");
                } else {
                  this.$message({
                    message: res.msg,
                    type: "warning",
                  });
                }
              });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    deliveryGoodsQuantityChange(currentValue, scope) {
      const { order } = this;
      if (order.paymentType != "1" || order.paymentSt != 9) {
        return;
      }
      const { row, $index } = scope;
      if (currentValue != row.goodsQuantity) {
        this.$set(this.goodsListCopy[$index], "remark", `货款退差额  ￥${(row.sellFactPrice * (row.goodsQuantity - currentValue)).toFixed(2)}`);
      } else {
        this.$set(this.goodsListCopy[$index], "remark", ``);
      }

      this.balanceRefundTotal = this.goodsListCopy
        .reduce((pre, cur) => pre + Number(cur.sellFactPrice * (cur.goodsQuantity - cur.deliveryGoodsQuantity)), 0)
        .toFixed(2);
    },
    actualSendQuantityChange() {
      const { order, goodsListCopy } = this;
      if (order.paymentType != "1" || order.paymentSt != 9) {
        return;
      }

      // const pickupQuantity = Number(order.vehicleList.reduce((pre, cur) => pre + Number(cur.pickupQuantity), 0)
      //   .toFixed(2))
      // const actualSendQuantity = Number(order.vehicleList.reduce((pre, cur) => pre + Number(cur.actualSendQuantity || 0), 0)
      //   .toFixed(2))

      // this.balanceRefundTotal = goodsListCopy
      //   .reduce((pre, cur) => pre + Number(cur.sellFactPrice * (pickupQuantity - actualSendQuantity)), 0)
      //   .toFixed(2);
      this.getBalanceRefundTotal();
    },
    getBalanceRefundTotal() {
      const actualSendTotal = Number(this.order.vehicleList.reduce((pre, cur) => pre + Number(cur.actualSendQuantity || 0), 0)
        .toFixed(2))
      this.balanceRefundTotal = (this.goodsListCopy[0].sellFactPrice * (Number(this.goodsListCopy[0].goodsQuantity) - actualSendTotal )).toFixed(2);
    },
    contractPreviewConfirm() {
      this.contractPreviewVisible = false;
      this.contractPreviewSign = true;
      this.toConfirmSelfPickupSubmit();
    },
    async importCarSuccess(response){
      if (response.code == "0") {
        const { order } = this;
        if (this.$refs.importCarUpload) {
          this.$refs.importCarUpload.clearFiles()
        }
        
        const loading = this.$loading({
          lock: true,
          text: "加载中...",
        });
        const { msg, code, data } = await requestApi.post('scbasic/member/membervehicle/mj/importVehicle', {
          fileUrl: response.data.url,
          cusBoId: order.identityId,
        })
        const { importMsg, successImportList } = data;
        loading.close();
        if (code == "0") {
          if (importMsg) {
            this.$alert(
              importMsg,
              '提示',
              {
                dangerouslyUseHTMLString: true,
              }
            )
            return;
          }
          if (!successImportList || !successImportList.length) {
            this.$message.warning('文件为空');
            return;
          }
          this.importCarVisible = false;
          this.$message.success('操作成功');
          const pickupGoodsUnit = order.vehicleList[0].pickupGoodsUnit;
          const vehicleList = successImportList.map((item) => ({
            ...item,
            vehicleId: item.id,
            quantity: item.pickupQuantity || undefined,
            encryptionIdCard: item.idCard,
            pickupGoodsUnit,
            actualSendQuantity: item.actualSendQuantity || undefined,
          }));
          this.$set(this.order, 'vehicleList', vehicleList)
          this.getBalanceRefundTotal();
        } else {
          this.$message.error(msg || '导入失败');
        }
      }
    },
    importCarBeforeUpload(file) {
      const fileName = file.name;
      const fileExtension = fileName.substring(fileName.lastIndexOf('.')).toLowerCase();
      
      const allowedExtensions = ['.xlsx', '.xls'];
      
      if (!allowedExtensions.includes(fileExtension)) {
        ElMessage.warning('只能上传 Excel 文件(.xlsx 或 .xls)!');
        return false;
      }
      
      // 可选:检查文件大小(例如限制10MB)
      const isLt60M = file.size / 1024 / 1024 < 60;
      if (!isLt60M) {
        ElMessage.warning('上传文件大小不能超过 60MB!');
        return false;
      }
      
      return true;
    },
    
    // 新增车辆
    async addCarConfirm(formData) {
      const { order } = this;

      const loading = this.$loading({
        lock: true,
        text: "加载中...",
      });
      const { msg, code, data } = await requestApi.post("scbasic/member/membervehicle/mj/add", {
        ...formData,
        cusBoId: order.identityId,
      });
      loading.close();
      if (code === "0") {
        this.$message.success("操作成功");
        const pickupGoodsUnit = order.vehicleList[0].pickupGoodsUnit;
        const vehicleItem = {
          ...data,
          quantity: "",
          vehicleId: data.id,
          encryptionIdCard: data.idCard,
          pickupGoodsUnit,
          pickupQuantity: data.pickupQuantity || undefined,
          actualSendQuantity: data.actualSendQuantity || undefined,
        }
        this.order.vehicleList.push(vehicleItem);
      } else {
        this.$message.error(msg);
      }
    },

    // 自提车辆合计
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 3) {
          sums[index] = "合计";
          return;
        }
        if (index === 4) {
          sums[index] = this.orderGoodsList[0].goodsQuantity;
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (column.property === "actualSendQuantity") {
          const sum = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = Number(sum.toFixed(4))
        } else {
          sums[index] = "";
        }
      });

      return sums;
    }
  },
};
